import React from 'react'
import styled from 'styled-components'

import { FONTS } from '../../../constants'

export const CreateFormTab = ({ activeTab, handleClickTab }) => {
  return (
    <Root>
      <Item
        active={ activeTab === 0 }
        onClick={ () => handleClickTab(0) }
      >
        Personal Info.
      </Item>
      <Item
        active={ activeTab === 1 }
        onClick={ () => handleClickTab(1) }
      >
          Company Info.
      </Item>
      <Item
        active={ activeTab === 2 }
        onClick={ () => handleClickTab(2) }
      >
          Movements
      </Item>
      <Item
        active={ activeTab === 3 }
        onClick={ () => handleClickTab(3) }
      >
          Privilege Role
      </Item>
    </Root>
  )
}

const Root = styled.div`
  height: 42px;
  display: flex;
  background: #F9F9F9;
  padding: 0 16px;
`

const Item = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 16px;
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.SMALL_SIZE};
  color: ${p => (p.active ? '#D44B49' : '#808080')};
  border-bottom: ${p => (p.active ? '2px solid #D44B49' : 'none')};
  cursor: pointer;
  ${p => !p.active && `
      margin-bottom: 2px;
  `}

  :nth-child(1) {
      margin-left: 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/new-employee/create-form/tab.js